import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const ProjectAdminContainer = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  m: { sm: '300' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    height: 93vh;
    border-radius: 4px;
  `}
`;

export const ProjectConfigurationTitle = styled(Box).attrs({
  p: { sm: '500' },
})`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
